module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/252-mexico-2f7f43b94136a9ec8b25d7a1badedbb3.svg";